import styled from 'styled-components';

export const Wrapper = styled.div`
  /* BaseCSS grid utility classes used in index.tsx for layout */
`;

export const ImageWrapper = styled.div<{ width: number }>`
  width: ${props => props.width ?? 0}px;
`;
